//      
                                             
                                                                        
                                         

                            
               
                              
                                
                      
                       
  

// the UCL prefers the mounting price (incl. fitting) whenever a product can be mounted
export const CHANNEL_PRIORITY           = ["mounting", "pickup", "shipping"];

export const determineDistributionChannelForPriceDisplay = (
	product          ,
	priority           = CHANNEL_PRIORITY
)                       => {
	const channels = (product && product.distributionChannels) || {};
	const key = priority.find(name => !!channels[name]);
	return key ? channels[key] : null;
};

/**
 * Resolves the prices shown for a product (#55467, same rules as the HPM, see #54225):
 * - the 30-day lowest price is the strike-through reference; the backend only delivers it when the
 *   current price is a real reduction (1 EUR or 1 % rule), so its presence means "on sale",
 * - the discount rate relates to the 30-day lowest price and is 0 when it is too small to advertise,
 *   in which case the 30-day price is shown without strike-through and percentage,
 * - the RRP is displayed separately ("originally ..."); the backend already hides it when it would
 *   undercut the current price or the 30-day lowest price.
 * While on sale all prices are taken from the same distribution channel so that price, 30-day lowest
 * price and discount rate stay consistent (channel prices include mounting costs where applicable).
 */
export const resolvePriceDisplay = (product         , priority           = CHANNEL_PRIORITY)               => {
	const channel = determineDistributionChannelForPriceDisplay(product, priority);
	const historicMinimalPrice = channel && channel.historicMinimalPrice ? channel.historicMinimalPrice : null;
	const isOnSale = !!historicMinimalPrice;
	const discountRate = isOnSale && channel && channel.discountRate > 0 ? channel.discountRate : 0;

	return {
		price: (isOnSale && channel && channel.price) || product.price || null,
		historicMinimalPrice,
		recommendedRetailPrice: (isOnSale && channel && channel.recommendedRetailPrice) || product.recommendedRetailPrice || null,
		discountRate,
		isDiscounted: discountRate > 0,
	};
};

export const formatMeasuringUnit = (measuringUnit        )         =>
	measuringUnit === "sqm" ? "m²" : measuringUnit === "cbm" ? "m³" : measuringUnit;
